function toggleCollapse ( element ) {
	if ( $(element).is(':hidden') ) {
		$(element).slideDown();
	} else {
		$(element).slideUp();
	}
}

function equalChildHeight () {
	$('.equal-child-height').each(function(){
		var highest = 0;
		$(this).children().each(function(){
			if ( $(this).height() > highest ) {
				highest = $(this).height();
			}
		});
		$(this).children().height(highest);
	});
}
/*
function initJSButtons () {
	$('.js-btn').each(function(){
		var onclick = $(this).data('onclick');
		if ( onclick ) {
			var func = window[onclick.function];
			if ( typeof func === 'function' ) {
				$(this).click(function(){
					func(onclick.parameters.join(','));
				});
			}
		}
	});
}
*/

iosSliderData = {
    clicked: false,
    target: ''
}

function alphabeticalMenuLetterClick ( element, target ) {
	$(element).parent().toggleClass('active');
	$(element).parent().siblings().removeClass('active');
	toggleCollapse(target);
	$(target).siblings().filter(':visible').slideUp();
    iosSliderData.clicked = true;
    setTimeout(function(){
        iosSliderData.clicked = false;
    }, 300);
}

function initAlphabetSlider () {
	if ( !$('#alphabetical-menu').is(':hidden') ) {
		$('#alphabetical-slider').iosSlider({
			desktopClickDrag: true,
			snapToChildren: true,
			onSlideComplete: function ( args ) {
                if(!args.slideChanged && !iosSliderData.clicked) {
                    alphabeticalMenuLetterClick(iosSliderData.target, "#" + $(iosSliderData.target).text() + "-content-wrapper");
                }
				if(args.currentSlideNumber == 1) {
					args.sliderContainerObject.parent().find('.icon-back:first').removeClass('active');
                    args.sliderContainerObject.parent().find('.icon-forward:first').addClass('active');
				} else if(args.currentSlideNumber == 10) {
					args.sliderContainerObject.parent().find('.icon-forward:first').removeClass('active');
                    args.sliderContainerObject.parent().find('.icon-back:first').addClass('active');
				} else {
					args.sliderContainerObject.parent().find('.icon-back:first').addClass('active');
					args.sliderContainerObject.parent().find('.icon-forward:first').addClass('active');
				}
                $('#alphabetical-slider').data('currentSlide', args.currentSlideNumber);
			}
		});
		$('#alphabetical-slider').data('currentSlide', 0);

        $('#alphabetical-slider li').mousedown(function(e){
            iosSliderData.target = $(this).find("a");
        });
	}
}

function toggleAlphabeticalMenu ( button ) {
	var menu = $('#alphabetical-menu');
	if ( menu.is(':hidden') ) {
		menu.slideDown({complete: function(){ initAlphabetSlider(); }});
	} else {
		menu.slideUp();
	}
	$(button).toggleClass('active');
}

function slideIosslider ( slider, steps, direction ) {
	var currentSlide = $(slider).data('currentSlide');
	var slideTo = 1;
	if ( direction == 'left' ) {
		if ( currentSlide == 1 )
			return;
		slideTo = $(slider).data('currentSlide') - steps;
		if ( slideTo < 1 )
			slideTo = 1;
	} else {
		var maxRightSlide = $(slider).data('iosslider').childrenOffsets.length;
		if ( currentSlide == maxRightSlide  )
			return;
		slideTo = $(slider).data('currentSlide') + steps;
		if ( slideTo > maxRightSlide )
			slideTo = maxRightSlide;
	}
	$(slider).iosSlider('goToSlide', slideTo);
}

function shareOnTwitter () {
	var twiiterUrl = 'http://twitter.com/share',
		width  = 575,
		height = 400,
		left   = ($(window).width()  - width)  / 2,
		top    = ($(window).height() - height) / 2,
		url    = document.URL,
		opts   = 'status=1' +
			',width='  + width  +
			',height=' + height +
			',top='    + top    +
			',left='   + left;

	window.open(twiiterUrl, 'twitter', opts);
}

function shareByEmail () {
	var url = 'mailto:?subject=Se denne saken på klikk.no&body=' + document.URL;
	window.open(url, '_blank');
}

function shareOnFacebbok () {
	var obj = {
		method: 'share',
		href: document.URL
	};
	function callback(response){}
	FB.ui(obj, callback);
}

// Init facebook API
window.fbAsyncInit = function(){
	FB.init(
		{
			appId: '162131997131905',
			status: true,
			cookie: true,
			xfbml: true,
			version: 'v2.0'
		}
	);
};

(function(d, s, id){
	var js, fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) {return;}
	js = d.createElement(s); js.id = id;
	js.src = "//connect.facebook.net/en_US/sdk.js";
	fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
// End inint facefoob API

function loadApotek1WidgetContent ( productSearchUrl, query, limit ) {
	$.ajax({
		url: productSearchUrl + 'apotek1/',
		data: {
			q: query,
			limit: limit
		},
		dataType: 'jsonp',
		jsonpCallback: "productsCallback",
		success: function(data){
			$(data).each(function(i) {
				var product = $(".widget_apotek1 .productClone").clone().removeClass("productClone hide").addClass("product item" + i);
				product.find(".image").css("backgroundImage", "url('" + this.image + "/200/200')");
				product.find(".title a").text(this.title).attr("href", this.url + "/?utm_source=Klikk.no&utm_medium=Banner&utm_term=" + this.productId + "&utm_campaign=Widget");
				product.find(".description").text((this.description.length > 90 ? this.description.substring(0, 90) : this.description));
				product.find(".price").text(this.listPrice);
				product.find(".buy").attr("href", this.url + "/?utm_source=Klikk.no&utm_medium=Banner&utm_term=" + this.productId + "&utm_campaign=Widget");
				product.appendTo($(".widget_apotek1 .products"));
				if(i > 2) return false;
			});
			if(data.length > 0)
				$(".widget_apotek1").show();
			var products = $('.widget_apotek1 .product');
			var highest = 0;
			$(products).each(function(){
				if ( $(this).height() > highest )
					highest = $(this).height();
			});
			$(products).height(highest + 40);
		}
	});
}

$(document).ready(function(){
    $('.helseleksikon form:first').on("submit", function(){
        $(this).find('input:text').each(function(){
            var that = $(this);
            that.val($.trim(that.val()));
        });
    });
});

$(function(){
	initAlphabetSlider();
	equalChildHeight();
});

// *******************************************************************************************************
//*************************** Javascript utility functions for Klikk *************************************
// *******************************************************************************************************

var $ = jQuery.noConflict();

// *******************************************************************************************************
// Check if ad is booked
function isAdBooked(placement){
    if(document.getElementById(placement) == null){
        return false;
    }    
    var adContainerHtml = document.getElementById(placement).innerHTML.toLowerCase();
    return adContainerHtml.indexOf('<a') > -1 || adContainerHtml.indexOf('<object') > -1 || adContainerHtml.indexOf('<embed') > -1;
}

// *******************************************************************************************************

function reloadPage() {
    location.reload();
}

// *******************************************************************************************************
// Ajax updater
function createAjaxUpdater(url, container, counter){
    ajaxCounter ++;
    $("#"+container).attr("id", container+counter).addClass("ajaxloadedContent");
    var jqxhr = $.get(url, function(data){
        $("#"+container+counter).append(data);
        $("#"+container+counter+" .ajaxLoader").hide();
    })
    .error(function(){ $("#"+container+counter+" .ajaxLoader").hide(); });
}

// *******************************************************************************************************
// jQuery UI dialog (lightbox)
$(document).ready(function() {
    $('.jq_dialog').click(function (){
        var id = $(this).attr('id').split("_")[1];
        displayIframeDialog(id);
    });
});
function displayIframeDialog(id){
    $('#'+id).dialog({
        autoOpen: true,
        modal: true,
        width: 400,
        position: 'center',
        title: "Snakk.klikk.no",
        zIndex: 10002
    });
}

// *******************************************************************************************************
// Sticky add
$(document).ready(function() {
    // Get position values
    var scrollPos = 0;
    var stickLeft = false;
    var stickRight = false;
    var useRightSticky = false;
    var readRightStickyStartpos = true; // Used for IE bugfix
    var useLeftSticky = false;
    var readLeftStickyStartpos = true; // Used for IE bugfix
    var paddingTop = 0;
    var googletopBar = 0; // Add spacing on top if googleBar exist
//        var facebookCommentsHeight = 0;

    if($(".googleTopBarFullwidth").length){
        googletopBar = 70;
        paddingTop += googletopBar;

    }
    if($(".leftSticky").length ){
        var leftStickyStartpos = $(".leftSticky").offset().top-googletopBar;
        useLeftSticky = true;
    }
    if($("#rightSticky").length){ 
        var rightStickyStartpos = $("#rightSticky").offset().top-googletopBar;
        var rightStickyStopBottom = ($(".box804.article").offset().top+$(".box804.article").height())-$("#rightSticky").height()+googletopBar;
        var rightStickyBottompos = (($(".box804.article").offset().top+$(".box804.article").height())-$("#rightSticky").height())-rightStickyStartpos-googletopBar;
        // If room for right sticky
        if(($("#moveOuterRightAdCol").offset().top+$("#moveOuterRightAdCol").height())-$("#rightSticky").height() < rightStickyStopBottom) useRightSticky = true;
    }

    $(window).scroll(function(e){

        if($(".googleTopBarFullwidth").css('display') == "none" && paddingTop > 5){
            leftStickyStartpos += googletopBar;
            rightStickyStartpos += googletopBar;
            rightStickyStopBottom += googletopBar;
            googletopBar = 0;
            paddingTop = 0;
            stickLeft = false;
            stickRight = false;
        }

        scrollPos = $(window).scrollTop();
        // Left sticky positioning
        if(useLeftSticky){
            if(readLeftStickyStartpos) leftStickyStartpos = $(".leftSticky").offset().top-googletopBar;

            if(leftStickyStartpos-scrollPos < 0 && !stickLeft){
                $(".leftSticky").css({"position":"fixed", "top":paddingTop});
                stickLeft = true;
                readLeftStickyStartpos = false;
            }
            else if(leftStickyStartpos-scrollPos > 0 && stickLeft){
                $(".leftSticky").css({"position":"relative", "top":"0px"});
                stickLeft = false;
            }
        }

        // Right sticky positioning
        if(useRightSticky){
            if(readRightStickyStartpos){
                rightStickyStartpos = $("#rightSticky").offset().top-googletopBar;
                rightStickyBottompos = (($(".box804.article").offset().top+$(".box804.article").height())-$("#rightSticky").height())-rightStickyStartpos-googletopBar;
            }
//                if($("#facebookCommentsHeight").length) facebookCommentsHeight = $("#facebookCommentsHeight").height();

            var bottomPos = (($(".box804.article").offset().top+$(".box804.article").height())-scrollPos)-$("#rightSticky").height()-googletopBar;
            if(rightStickyStartpos-scrollPos > 0 && stickRight){
                $("#rightSticky").css({"position":"static", "padding-left":"0", "margin-top":"0px"});
                stickRight = false;
            }
            else if(rightStickyStartpos-scrollPos < 0 && bottomPos > 0 && !stickRight){
                $("#rightSticky").css({"position":"fixed", "top":paddingTop+5, "padding-left":"0px", "margin-top":"0", "width":"180px"});
                stickRight = true;
                readRightStickyStartpos = false;
            }
            else if(bottomPos < 0 && stickRight){
                $("#rightSticky").css({"position":"static", "margin-top":rightStickyBottompos, "padding-left":"0px"});
                stickRight = false;
            }
        }
    });
});

// *******************************************************************************************************
// Code for multipage navigation
/*
    Forutsetter at vi har en array 'pages' som inneholder elementer 'hiddenPageX' for hver side
    Og for bilder - en array "images" som ineholder elementer "image_bodyX" for hver side/hvert bilde

    EKSEMPEL:
    pages = new Array();
    pages[0] = "hiddenPage1";
*/

current = 'hiddenPage1';

function switchPage(next, number) {
    // number = parameter...
    // hide all pages:
    for (var x = 0; x < pages.length; x++) {
        // alert(pages[x] + " " + thePage);
        hide(pages[x]);
    }

    // show the next page:
    show(next);
    // update the 'current' marker:
    current = next;
}

function switchToNextPage() {
    // switch for: current (and number can be 10: 2 digits:)
    if (current.length < 12)
        number = current.substring(current.length, current.length -1);
    else
        number = current.substring(current.length, current.length -2);
    last = pages.length;
    // check that the current page is not the last page:
    if(number != last){
        // it's good - exec00te!
        for (var x = 0; x < pages.length; x++) {
            hide(pages[x]);
        }
        show(pages[number]);
        current = pages[number]; // update the 'current' marker
    }
}

function switchToPreviousPage() {
    // switch for: current (and number can be 10: 2 digits:)
    if (current.length < 12)
        number = current.substring(current.length, current.length -1);
    else
        number = current.substring(current.length, current.length -2);

    // check that the current page is not the first page:
    if(number != 1){
        // it's good - exec00te!
        for (var x = 0; x < pages.length; x++) {
            hide(pages[x]);
        }
        show(pages[number -2]);
        current = pages[number -2]; // update the 'current' marker
    }
}

// function hide gj�r 3 ting - gjemmer text div, setter markering for side nummeret og gjemmer bildet knyttet til siden.
function hide(theid) { // ta med id til <li> med bg image - endre class til "page notselected".
    if (document.getElementById) {
        var hide_id = document.getElementById(theid);
        hide_id.className = 'mparticle hide';
    }
}

// function show gj�r 3 ting, samme som "hide", bare motsatt.
function show(theid) { // ta med id til <li> med bg image - endre class til "page selected"
    if (document.getElementById) {
        var show_id = document.getElementById(theid);
        show_id.className = 'mparticle show';
    }
}

// *******************************************************************************************************
// Code for embed Recipe

$(document).ready(function() {
    $('.embedRecipeButton').click(function(){
        var embedRecipe = $(this).parents(".recipe_klikk").find(".embedRecipe");
        if(embedRecipe.length == 0) var embedRecipe = $(".recipeContent").find(".embedRecipe");     
        if(embedRecipe.is(":hidden")){
            embedRecipe.find(".createCode").click();
        }
        embedRecipe.slideToggle('400');
    });
    $('.createCode').click(function(){
        var width = $(this).siblings('#embedSizeWidth').val();
        var height = $(this).siblings('#embedSizeHeight').val();
        var id = $(this).parents(".embedRecipe").attr("title");
        if(width >= 400){
            var ads = "true";
            if(width < 530) ads = "false";
            $(this).siblings('.embedCode').val('<iframe src="http://www.klikk.no/index.jsp?service=embedRecipe&recipe='+id+'&ads='+ads+'" id="klikk_recipe" frameborder="0" height="' + height + '" width="' + width + '"></iframe>');
        }else{
            if(!$(".embedError .errorTxt").is(":visible") && $(".recipeContent").find(".embedRecipe").is(":visible")){
                $(".embedError .errorTxt").fadeIn(200).delay(5000).fadeOut(1000);
            }
        }
    });
    $('.embedCode').click(function(){
        $(this).select();
    });
});

// *****************************************************************************************************
// Code to reload iframes in dynamic wireframe

$(document).ready(function() {
    $(".reloadDynamicContent").click(function(){
        $(".reloadableIframeAd").each(function(){
            $(this).attr("src", $(this).attr("src"));
        });
        $("#klikkKolofonIframe").attr("src", $("#klikkKolofonIframe").attr("src"));
    });
});

// *****************************************************************************************************
// hmi jquery plugin
(function($){
	var methods = {
        settings : {
            description: "jQuery HMI plugin"
        },
		init : function(settings){
			if(settings) $().extend(methods.settings, settings);
            $("body").delegate(".fbs_shareResult", "click", function(){
                $().hmi("fbShare");
                return false;
            });
            $("#reportRecipe").click(function(){
                methods.reportRecipe(this);
            });
            $("#toggleIsSocial").click(function(){
                methods.toggleSocialRecipes();
            });
		},
        toggleSocialRecipes: function(){
            var url = document.URL;
            if(url.indexOf("fq=isSocial:false") > -1){
                var url = url.replace(url.substring(url.indexOf("fq=isSocial:false"), url.indexOf("fq=isSocial:false") + "fq=isSocial:false".length + 1), "");
                if(url.indexOf("&", url.length-1) !== -1 || url.indexOf("?", url.length-1) !== -1)
                    window.location = url.substring(0, url.length - 1);
                else
                    window.location = url;
            }
            else
                window.location = url + (url.indexOf("?") ==  -1 ? "?" : "&") + "fq=isSocial:false";
        },
        reportRecipe: function(that){
            var cookie = methods.getCookie("klikkRecipe_reported");
            if(typeof cookie === "string") cookie = cookie.split("|");
            if(cookie.indexOf($(that).data("recipeid").toString()) == -1){
                $.ajax({
                    url: methods.settings.adminUrl + "/report.htm",
                    data: {
                        id: $(that).data("recipeid")
                    },
                    dataType: "jsonp"
                });
                methods.setCookie("klikkRecipe_reported", [$(that).data("recipeid")], 61320);
            }
            $(that).removeAttr("id").css({
                opacity: "0.5",
                cursor: "default"
            }).addClass("noUnderline").text("Rapportert");
        },
        setCookie: function(name, value, hours){
            var cookie = methods.getCookie(name);
            if(typeof value === "object"){
                if(typeof cookie === "object"){
                    cookie.push(value[0]);
                    cookie = cookie.join("|");
                }else{
                    if(cookie.length > 0)
                        cookie = cookie + "|" + value;
                    else
                        cookie = value;
                }
            }else{
                cookie = value;
            }
            var d = new Date();
            d.setTime(d.getTime()+((hours || 24)*60*60*1000));
            var expires = "expires="+d.toGMTString();
            var host = window.location.hostname.split(".");
            if(host.length > 1)
                host.shift();
            if(host.length > 1){
                host = host.join(".");
                document.cookie = name + "=" + cookie + "; " + expires + "; domain=" + host + "; path=/;";
            }else{
                document.cookie = name + "=" + cookie + "; " + expires + "; path=/;";
            }
        },
        getCookie: function(name){
            var name = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0; i<ca.length; i++){
                var c = ca[i].trim();
                if (c.indexOf(name)==0){
                    var value =  c.substring(name.length,c.length);
                    if(value.indexOf("|") > -1)
                        return value.split("|");
                    else
                        return value;
                }
            }
            return "";
        },
        removeCookie: function(name){
            var host = window.location.hostname.split(".");
            if(host.length > 1)
                host.shift();
            host = host.join(".");
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" + host + "; path=/;";
        },
        getJsonFromXml : function(params, callback){
            var source = "";
            if(params.artId != null)
                source = "id=" + params.artId;
            else if(params.url != null)
                source = "url=" + encodeURI(params.url);
            if(source !== "" && params.pubUrl != null){
                $.ajax({
                    type:'post',
                    scriptCharset:"utf-8",
                    url: params.pubUrl + "index.jsp?service=xmlToJson",
                    data: source,
                    dataType:"json",
                    success : function(data){
                        callback(data);
                    },
                    error : function(){
                        callback("error");
                    }
                });
            }
        },
        initFbShare : function(params){ // fbShareTitle, fbShareCaption, fbSharePicture
            $.extend(methods.settings, params);
            return this;
        },
        fbShare : function(){
            var url = "https://www.facebook.com/dialog/feed?app_id=162131997131905&link=" + window.location.href + "&picture=" + methods.settings.fbSharePicture + "&name=" + methods.settings.fbShareTitle + "&caption=" + methods.settings.fbShareCaption + "&description=klikk.no&redirect_uri=" + window.location.href;
            window.open(url);
        },
        hideIframes : function(){
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                document.write("<style type='text/css'>@-moz-document url-prefix(){ iframe{display:none;} }</style>");
            }
        },
        reloadIframes : function(){
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                $("iframe").each(function(){
                    $(this).attr('src', $(this).attr('src'));
                });
                document.write("<style type='text/css'>@-moz-document url-prefix(){ iframe{display:block;} }</style>");
            }
        }
	};

	$.fn.hmi = function(method){
		if(methods[method])
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		else if(typeof method === 'object' || !method)
			return methods.init.apply(this, arguments);
		else
			$.error('Method ' +  method + ' does not exist on jQuery.hmi');
	};
})(jQuery);